export default __webpack_public_path__ + "static/media/Gabiel2.5fcd04d9.png";